import { Button } from '@/design-system';

/**
 * SPEC-007 SAVE-REQ-015/T052 — a 409 stops autosave and must never force an
 * overwrite. Both actions here are explicit and safe: reload takes the
 * server's graph, keep-local dismisses the dialog without touching the
 * server (the recovery record written on conflict is the safety net).
 */
export function ConflictDialog({
  onReload,
  onKeepLocal,
}: {
  onReload: () => void;
  onKeepLocal: () => void;
}) {
  return (
    <div
      role="alertdialog"
      aria-label="Conflito detectado"
      className="border-b border-[rgba(226,85,85,0.35)] bg-[rgba(226,85,85,0.1)] px-4 py-3"
    >
      <p className="text-sm font-medium text-[#f08484]">
        Este funil foi alterado em outro lugar. O salvamento automático foi interrompido para evitar sobrescrevê-lo.
      </p>
      <p className="mt-1 text-xs text-text-secondary">
        Suas alterações locais foram preservadas e salvas neste dispositivo. Recarregue para ver a versão
        mais recente ou continue trabalhando localmente, sem salvar, até decidir.
      </p>
      <div className="mt-2 flex gap-2">
        <Button variant="primary" onClick={onReload}>
          Recarregar versão do servidor
        </Button>
        <Button variant="secondary" onClick={onKeepLocal}>
          Manter recuperação local
        </Button>
      </div>
    </div>
  );
}
